import React from 'react'
import BulletPoint from 'scenes/Dashboard/components/BulletPoint'
import { makeStyles } from 'tss-react/mui'

import { Typography } from '@mui/material'

type OtherTractionMetricsProps = {
  otherTractionMetrics: string
}

export const OtherTractionMetrics = ({ otherTractionMetrics }: OtherTractionMetricsProps) => {
  const { classes } = useStyles()
  return (
    <>
      <Typography variant="body2" className={classes.titleLabel}>
        {'Initial other traction metrics (Manually added by user)'}
      </Typography>
      <BulletPoint
        className={classes.bulletPoint}
        item={<Typography variant="body2">{otherTractionMetrics}</Typography>}
      />
    </>
  )
}

OtherTractionMetrics.displayName = 'OtherTractionMetrics'

const useStyles = makeStyles()(() => ({
  titleLabel: {
    fontWeight: 'bold',
  },
  bulletPoint: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}))
